import {
  Button,
  ButtonIcon,
  ButtonSpinner,
  ButtonText,
} from "@repo/components/src/ui/button";
import { ComponentProps, memo, useCallback, useMemo } from "react";

type LoadingButtonProps = Omit<ComponentProps<typeof Button>, "children"> & {
  loading?: boolean;
  loadingText?: string;
  children?: React.ReactNode;
  startIcon?: ComponentProps<typeof ButtonIcon>["as"];
};

const LoadingButton = memo(function LoadingButton(props: LoadingButtonProps) {
  const {
    loading,
    isDisabled,
    children,
    loadingText,
    startIcon,
    ...restProps
  } = props;
  const text = useMemo(
    () => (loading ? loadingText || children : children),
    [loading, children, loadingText],
  );
  const renderStartIcon = useCallback(() => {
    if (loading) {
      return <ButtonSpinner />;
    } else if (startIcon) {
      return <ButtonIcon as={startIcon} />;
    }
    return <></>;
  }, [loading, startIcon]);
  return (
    <Button isDisabled={isDisabled || loading} {...restProps}>
      {renderStartIcon()}
      {typeof text === "string" ? <ButtonText>{text}</ButtonText> : text}
    </Button>
  );
});

export default LoadingButton;
